import { CloseOutlined, InfoCircleFilled, RightOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Button, Space } from 'antd';
import { useInvalidAccount, useSetInvalidAccount } from 'hooks/business/account';
import React, { useState } from 'react';
import { useTranslate } from '@tolgee/react';
import UpdateAccountModal from './Modal';

const Notice = styled.div`
  background-color: var(--fett-surface-warning-bg);
  border-radius: 2px;
  padding: 9px 16px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .info-icon {
    color: var(--fett-surface-warning-text);
  }
`;

interface Props {
  onClose: () => void;
}

const BatchUpdateAccountTip = (props: Props) => {
  const { onClose } = props;
  const [visible, setVisible] = useState(false);
  const [close, setClose] = useState(false);
  const data = useInvalidAccount();
  const refresh = useSetInvalidAccount();
  const { t } = useTranslate();
  if (close || !data.length) {
    return null;
  }
  return (
    <>
      <Notice>
        <Space>
          <InfoCircleFilled className="info-icon" />
          {t('ViewShops.有x家店铺需要更新帐号信息', { num: data.length })}
          <Button type="link" onClick={() => setVisible(true)}>
            {t('ViewShops.去更新')}
            <RightOutlined />
          </Button>
        </Space>
        <CloseOutlined onClick={() => setClose(true)} />
      </Notice>
      <UpdateAccountModal
        mode="multiple"
        list={data}
        visible={visible}
        onCancel={() => {
          setVisible(false);
          onClose();
        }}
        onOk={() => setVisible(false)}
        refresh={refresh}
      />
    </>
  );
};

export default BatchUpdateAccountTip;
